"use client";

import { c as _c } from "react/compiler-runtime";
import type { ProductHit } from "@/lib/search/types";
import { SearchProductHit } from "./SearchProductHit";
interface Props {
  hits: ProductHit[];
}
export function SearchProductHitList(t0) {
  const $ = _c(4);
  const {
    hits
  } = t0;
  if (hits.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== hits) {
    t1 = hits.map(_temp);
    $[0] = hits;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <ul className="flex flex-col">{t1}</ul>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(hit, index) {
  return <li key={hit.sku}><SearchProductHit hit={hit} position={index} /></li>;
}